import React, { useEffect, Fragment, useState } from 'react'
import { groupBy } from 'libraries/lodash'
import { isValidResponse } from 'libraries/front-end-core/helpers/dataflow'
import { getTopLevelSections } from 'services/QAService'
import AolTiles from './AolTiles'
import QaTiledMenu from 'components/tiled-menu/QaTiledMenu'
import getUrl from 'libraries/front-end-core/core/url'
import { QA_CONTENT } from 'constants/controllers'

const groupSectionsByAol = (nodes, root, order) => {
  const tiles = getTopLevelSections(nodes, root, true)
  const grouped = groupBy(tiles, 'areaOfLaw')
  return order.reduce((acc, aol) => {
    if (grouped[aol]) acc[aol] = grouped[aol]
    return acc
  }, {})
}

function QAMenu ({
  flavour,
  isTiledMenuLoaded,
  isMobile,
  headerHeight,
  qaSections,
  showFavouritesOnly,
  favourites,
  keyword,
  order,
  ...props
}) {
  const [tiles, setTiles] = useState(
    groupSectionsByAol(
      qaSections[flavour].nodes,
      qaSections[flavour].root,
      order
    )
  )

  useEffect(() => {
    if (isValidResponse(qaSections)) {
      const { nodes, root } = qaSections[flavour]
      const grouped = groupSectionsByAol(nodes, root, order)
      setTiles(grouped)
    }
  }, [qaSections, flavour])

  return (
    <div className='bg-page-background'>
      <div className='layout-width-constraint pt8 pa7'>
        {Object.keys(tiles).map((aol, index, arr) => {
          const sections = tiles[aol]
          if (!sections || sections.length === 0) return null

          return (
            <Fragment key={`${aol}-tiles`}>
              <AolTiles
                key={`${aol}-qa-tiles`}
                aol={aol}
                focusedAol={props.focusedAol}
                pageId={props.pageId}
              >
                <QaTiledMenu
                  {...props}
                  flavour={flavour}
                  tiledMenu={{ topLevelSections: sections, nodes: qaSections[flavour].nodes }}
                  data-help-item='qatiles'
                  category='Q&A'
                  keyword={keyword}
                  aols={[aol]}
                  favourites={favourites}
                  showFavouritesOnly={showFavouritesOnly}
                  getUrl={params => getUrl(QA_CONTENT, { aol, flavour, ...params })}
                />
              </AolTiles>
              {index < (arr.length - 1) && <hr className='mt7 grey bg-grey' />}
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}
export default QAMenu
